import { render, staticRenderFns } from "./InnerWelcomeBannerPromotionComponent.vue?vue&type=template&id=675d5d03&scoped=true"
import script from "./InnerWelcomeBannerPromotionComponent.vue?vue&type=script&lang=js"
export * from "./InnerWelcomeBannerPromotionComponent.vue?vue&type=script&lang=js"
import style0 from "./InnerWelcomeBannerPromotionComponent.vue?vue&type=style&index=0&id=675d5d03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675d5d03",
  null
  
)

export default component.exports